import { compose, mapProps, setDisplayName } from 'recompose';

import { selectFields } from '../../lib/contentful/selectors';

export const enhance = compose(
  setDisplayName('RichText'),
  mapProps(({ content }) => ({ ...selectFields(content) }))
);
